module.exports = __webpack_public_path__ + "img/eye-protect-system-white.25d5a79a.svg";